export
const name: string = "Outlines";

export
const preproc: string = ``;

export
const declaration: string = `
    // override default precision specified in defaultPrecision_fs
    precision lowp float;

    uniform SMaterial u_material;
    uniform int u_blackwhite_outlines;
`;

export
const varyings: string = `
    varying float v_selected;
`;

export
const implementation: string = `
    void main()
    {
    #ifdef CLIPPING_PLANE
        if (resolveClippingPlane()) {
            gl_FragColor = vec4(clippingPlaneColor, 1.0);
            return;
        }
    #endif

        SMaterial material = u_material;

        if (v_selected > 0.5) {
            material.ambient = SELECTED_MATERIAL_AMBIENT;
            material.diffuse = u_selected_material_diffuse;
        }

        if (u_blackwhite_outlines == 2) {
            // color as it is
            gl_FragColor = applyLighting(material);
            gl_FragColor.a = 1.0; // ignore transparency for the outlines
        }
        else if (u_blackwhite_outlines == 3) {
            gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
        }
        else { // white is black or black is white based on background light/dark recognition
            // change the color so that for light background (0) we render white outline as black outline
            // and for black outlines or black background (1) we render the black outlines as white outline
            if (u_blackwhite_outlines == 0 && distance(material.diffuse, vec3(1, 1, 1)) < 0.0001) {
                gl_FragColor = vec4(vec3(0.0), 1.0);
            }
            else if (u_blackwhite_outlines == 1 && distance(material.diffuse, vec3(0, 0, 0)) < 0.0001) {
                gl_FragColor = vec4(vec3(0.0), 1.0);
            }
            else {
                gl_FragColor = applyLighting(material);
                gl_FragColor.a = 1.0; // ignore transparency for the outlines
            }
        }

    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
